import React, { useEffect, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { StyledPagination, PaginationPlaceholder } from './styles';
import { getURLParameter } from '#helper';

const LogPagination = ({
  history,
  initialPage,
  pages,
  changePageAction,
  getSearchParams
}) => {
  const dispatch = useDispatch();
  const page = Number(getURLParameter('page')) || initialPage;

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [page]);

  const handlePageChange = useCallback(
    (event, newPage) => {
      if (page !== newPage) {
        const {
          location: { search }
        } = history;
        const params = getSearchParams(search, { filterType: 'page', value: newPage });
        history.replace(`?${params}`);
        dispatch(changePageAction(newPage));
      }
    },
    [page, history, getSearchParams, dispatch, changePageAction]
  );

  if (pages && Number(pages) > 1) {
    return (
      <StyledPagination
        shape="rounded"
        color="secondary"
        count={pages}
        page={Number(page)}
        onChange={handlePageChange}
      />
    );
  }

  return <PaginationPlaceholder />;
};

export default LogPagination;
